/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getShifts } from 'app/entities/shift/shift.reducer';
import { getEntities as getDepartments } from 'app/entities/department/department.reducer';
import { getEntities as getWards } from 'app/entities/ward/ward.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './department-need.reducer';

export const DepartmentNeedUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const shifts = useAppSelector(state => state.shift.entities);
  const departments = useAppSelector(state => state.department.entities);
  const wards = useAppSelector(state => state.ward.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const departmentNeedEntity = useAppSelector(state => state.departmentNeed.entity);
  const loading = useAppSelector(state => state.departmentNeed.loading);
  const updating = useAppSelector(state => state.departmentNeed.updating);
  const updateSuccess = useAppSelector(state => state.departmentNeed.updateSuccess);

  const handleClose = () => {
    navigate(`/department-need${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getShifts({}));
    dispatch(getDepartments({}));
    dispatch(getWards({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.shiftDate !== undefined && typeof values.shiftDate !== 'number') {
      values.shiftDate = Number(values.shiftDate);
    }
    if (values.requestEndDate !== undefined && typeof values.requestEndDate !== 'number') {
      values.requestEndDate = Number(values.requestEndDate);
    }
    if (values.overTimeBonus !== undefined && typeof values.overTimeBonus !== 'number') {
      values.overTimeBonus = Number(values.overTimeBonus);
    }
    if (values.minskillLevel !== undefined && typeof values.minskillLevel !== 'number') {
      values.minskillLevel = Number(values.minskillLevel);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdate !== undefined && typeof values.lastUpdate !== 'number') {
      values.lastUpdate = Number(values.lastUpdate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.neededCount !== undefined && typeof values.neededCount !== 'number') {
      values.neededCount = Number(values.neededCount);
    }

    const entity = {
      ...departmentNeedEntity,
      ...values,
      shift: shifts.find(it => it.id.toString() === values.shift?.toString()),
      department: departments.find(it => it.id.toString() === values.department?.toString()),
      ward: wards.find(it => it.id.toString() === values.ward?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...departmentNeedEntity,
          shift: departmentNeedEntity?.shift?.id,
          department: departmentNeedEntity?.department?.id,
          ward: departmentNeedEntity?.ward?.id,
          hospital: departmentNeedEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.departmentNeed.home.createOrEditLabel" data-cy="DepartmentNeedCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.departmentNeed.home.createOrEditLabel">Create or edit a DepartmentNeed</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="department-need-id"
                  label={translate('tinyMedicRestApp.departmentNeed.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.shiftDate')}
                id="department-need-shiftDate"
                name="shiftDate"
                data-cy="shiftDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.requestEndDate')}
                id="department-need-requestEndDate"
                name="requestEndDate"
                data-cy="requestEndDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.overTimeBonus')}
                id="department-need-overTimeBonus"
                name="overTimeBonus"
                data-cy="overTimeBonus"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.minskillLevel')}
                id="department-need-minskillLevel"
                name="minskillLevel"
                data-cy="minskillLevel"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.active')}
                id="department-need-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.cursor')}
                id="department-need-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.lastUpdate')}
                id="department-need-lastUpdate"
                name="lastUpdate"
                data-cy="lastUpdate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.microSec')}
                id="department-need-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.timestampEntry')}
                id="department-need-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.departmentNeed.neededCount')}
                id="department-need-neededCount"
                name="neededCount"
                data-cy="neededCount"
                type="text"
              />
              <ValidatedField
                id="department-need-shift"
                name="shift"
                data-cy="shift"
                label={translate('tinyMedicRestApp.departmentNeed.shift')}
                type="select"
              >
                <option value="" key="0" />
                {shifts
                  ? shifts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="department-need-department"
                name="department"
                data-cy="department"
                label={translate('tinyMedicRestApp.departmentNeed.department')}
                type="select"
              >
                <option value="" key="0" />
                {departments
                  ? departments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="department-need-ward"
                name="ward"
                data-cy="ward"
                label={translate('tinyMedicRestApp.departmentNeed.ward')}
                type="select"
              >
                <option value="" key="0" />
                {wards
                  ? wards.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="department-need-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.departmentNeed.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/department-need" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DepartmentNeedUpdate;
